// createFabricObject.js
import text from './objects/text'
import image from './objects/image'
import shape from './objects/shape'

function validateObject(object) {
  if (!object) {
    throw new Error('createFabricObject: object is required')
  }

  if (!object.objectType) {
    throw new Error('createFabricObject: object.objectType is required')
  }

  return true
}

export default function (object, options) {

  validateObject(object)
  // console.log("createFabricObject", object)

  switch (object.objectType) {
    case 'i-text':
    case 'text':
      return text(object, options)
    case 'img':
    case 'image':
      return image(object, options)
    case 'shape':
    case 'path':
    case 'triangle':
    case 'circle':
    case 'hexagon':
    case 'rectangle':
    case 'line':
    case 'trapezoid':
      return shape(object, options)
    default:
      console.warn("createFabricObject: object.objectType not found or not supported.")
      return null
  }
}
